import { StoryblokCtaLeftAlign } from './StoryblokCtaLeftAlign'

import { createCtaLeftAlign } from './__mocks__/ctaLeftAlign'

export { createCtaLeftAlign }

// Re-export for backward compatibility
export const dummyBlokCtaLeftAlignPrimaryStoryblok = createCtaLeftAlign()
export const dummyBlokCtaLeftAlignSecondaryStoryblok = createCtaLeftAlign({
  buttonStyle: 'secondary',
})

export default StoryblokCtaLeftAlign
